module.exports = __webpack_public_path__ + "img/mp3.aaac2f9a.svg";